import api from '@/services/api'
const state = {
  reports:[],
  selectedReport: null,
  editMode: false
}
const getters = {
  reports: state => {
    return state.reports;
  },
  selectedReport: state => {
    return state.selectedReport;
  },
  editMode: state => {
    return state.editMode
  }
};

const mutations = {
  addNewReport(state, report) {
    let reports = state.reports;
    let id = new Date().getTime();
    report.id = id;
    reports.push(report);
    state.reports = reports;
  },
  toggleEditMode(state, status) {
    state.editMode = status
  },
  selectReport(state, id) {
    let report = state.reports.find(e => e.id == id);
    state.selectedReport = report;
  },
  addPageToReport(state, payload){
    let reportId = payload.id;
    let index = state.reports.map(e => e.id).indexOf(reportId);
    if(index >=0){
      let reports = [...state.reports];
      reports[index].pages = payload.pages;
      state.reports = reports;
      state.selectedReport = {...reports[index]};
    }
  },
  updateReport(state, payload){
    let reportId = payload.id;
    let index = state.reports.map(e => e.id).indexOf(reportId);
    if(index >=0){
      let report = [...state.reports][index];
      let pages = report.pages;
      let newSection = payload.section;
      let sections = pages ? pages[payload.pageIndex].sections : [];
      sections.push(newSection);
      report.pages[payload.pageIndex].sections = sections;

      state.reports[index] = report;
      state.selectedReport = {...report};
    }
  },
  updateTextDataInReport(state, payload){
    let reportId = payload.id;
    let index = state.reports.map(e => e.id).indexOf(reportId);
    if(index >=0){
      let report = [...state.reports][index];
      let sectionIndex = report.pages[payload.pageIndex].sections.findIndex(ele => {
        return ele.loc.colIndex == payload.colIndex && payload.rowIndex == ele.loc.rowIndex
      });
      report.pages[payload.pageIndex].sections[sectionIndex].editorData = payload.editorData;
      state.reports[index] = report;
      state.selectedReport = {...report};
    }
  },
  deleteSection(state, payload){
    let reportId = payload.id;
    let index = state.reports.map(e => e.id).indexOf(reportId);
    if(index >=0){
      let report = [...state.reports][index];
      let sectionIndex = report.pages[payload.pageIndex].sections.findIndex(ele => {
        return ele.loc.colIndex == payload.colIndex && payload.rowIndex == ele.loc.rowIndex
      });
      report.pages[payload.pageIndex].sections.splice(sectionIndex, 1);
      state.reports[index] = report;
      state.selectedReport = {...report};
    }
  },
  deletePage(state, payload){
    let reportId = payload.id;
    let pageIndex = payload.pageIndex;
    let reportIndex = state.reports.map(e => e.id).indexOf(reportId);
    if(reportIndex >=0){
      let report = [...state.reports][reportIndex];
      report.pages.splice(pageIndex, 1);
      state.reports[reportIndex] = {...report};
      state.selectedReport = {...report};
    }
  },
  updateReportTitle(state,payload){
    let reportId = payload.id;
    let reportIndex = state.reports.map(e => e.id).indexOf(reportId);
    if(reportIndex >=0){
      let report = [...state.reports][reportIndex];
      report.name = payload.name;
      state.reports[reportIndex] = {...report};
      state.selectedReport = {...report};
    }
  }
};

const actions = {
  addNewReport({commit}, data) {
    commit('addNewReport', data)
  },
  selectReport({commit}, data) {
    commit('selectReport', data)
  },
  addPageToReport({commit}, data) {
    commit('addPageToReport', data)
  },
  updateReport({commit}, data) {
    commit('updateReport', data)
  },
  updateTextDataInReport({commit}, data) {
    commit('updateTextDataInReport', data)
  },
  deleteSection({commit}, data) {
    commit('deleteSection', data)
  },
  deletePage({commit}, data) {
    commit('deletePage', data)
  },
  updateReportTitle({commit}, data) {
    commit('updateReportTitle', data)
  },
  toggleEditMode({commit}, status=false) {
    commit('toggleEditMode', status)
  },
}



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js